module.exports = __webpack_public_path__ + "media/Katze.283284a4.mp3";